import * as React from "react";
import { forwardRef } from "react";
import { chakra, useStyleConfig } from "@chakra-ui/react";
export const ExpandIcon = forwardRef(({ baseline = false, ...props }, ref) => {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return React.createElement(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props },
        React.createElement("path", { fillRule: "evenodd", d: "M14.75 3.75a1 1 0 1 0 0 2h2.086l-3.793 3.793a1 1 0 0 0 1.414 1.414l3.793-3.793V9.25a1 1 0 1 0 2 0v-4.5a1 1 0 0 0-1-1h-4.5Zm-9 11a1 1 0 1 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 1 0 0-2H7.164l3.793-3.793a1 1 0 0 0-1.414-1.414L5.75 16.836V14.75Z", clipRule: "evenodd" }));
});
ExpandIcon.displayName = "ExpandIcon";
